import * as React from 'react';

var _path, _ellipse, _ellipse2, _ellipse3, _path2, _ellipse4, _ellipse5, _ellipse6, _path3, _ellipse7, _ellipse8, _ellipse9, _path4, _ellipse10, _ellipse11, _circle, _path5, _path6, _path7, _ellipse12, _path8, _path9, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgRedirectIllustration = function SvgRedirectIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 215,
    height: 137,
    fill: "none",
    viewBox: "0 0 215 137"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#41E878",
    fillRule: "evenodd",
    d: "M211.792 96.102c.342 0 .619.277.619.619v1.704h1.635a.634.634 0 1 1 0 1.268h-1.635v1.704a.619.619 0 1 1-1.238 0v-1.704h-1.635a.633.633 0 0 1 0-1.268h1.635v-1.704c0-.342.277-.62.619-.62M179.709 115.816c.342 0 .619.277.619.619v1.705h1.635a.633.633 0 1 1 0 1.267h-1.635v1.705a.619.619 0 0 1-1.238 0v-1.705h-1.635a.633.633 0 0 1 0-1.267h1.635v-1.705c0-.342.277-.619.619-.619M141.209 76.388c.342 0 .619.277.619.618v1.705h1.635a.634.634 0 1 1 0 1.267h-1.635v1.705a.619.619 0 0 1-1.238 0v-1.705h-1.635a.633.633 0 0 1 0-1.267h1.635v-1.705c0-.341.277-.618.619-.618",
    clipRule: "evenodd"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "transparent",
    stroke: "#1493FF",
    strokeWidth: 2,
    className: "Circle",
    rx: 2.888,
    ry: 2.957,
    transform: "matrix(-1 0 0 1 190.367 80.844)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "transparent",
    stroke: "#1493FF",
    className: "Circle",
    rx: 1.604,
    ry: 1.643,
    transform: "matrix(-1 0 0 1 203.772 116.802)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "transparent",
    stroke: "#1493FF",
    strokeWidth: 2,
    className: "Circle",
    rx: 3.85,
    ry: 3.943,
    transform: "matrix(-1 0 0 1 148.267 105.959)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#41E878",
    fillRule: "evenodd",
    d: "M3.222 47.043a.62.62 0 0 0-.622.621v1.682H.95a.628.628 0 0 0 0 1.256H2.6v1.681a.621.621 0 0 0 1.243 0v-1.681h1.65a.628.628 0 1 0 0-1.256h-1.65v-1.681a.62.62 0 0 0-.621-.622M28.27 65.869a.62.62 0 0 0-.62.621v1.682H26a.628.628 0 1 0 0 1.256h1.65v1.681a.621.621 0 1 0 1.242 0v-1.681h1.65a.628.628 0 0 0 0-1.256h-1.65V66.49a.62.62 0 0 0-.622-.621M74.096 27.505a.62.62 0 0 0-.622.621v1.682h-1.65a.628.628 0 1 0 0 1.256h1.65v1.681a.621.621 0 0 0 1.243 0v-1.681h1.65a.628.628 0 0 0 0-1.256h-1.65v-1.682a.62.62 0 0 0-.621-.62",
    clipRule: "evenodd"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.06,
    cy: 22.661,
    fill: "transparent",
    stroke: "#1493FF",
    strokeWidth: 2,
    rx: 2.899,
    ry: 2.931
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.443,
    cy: 53.312,
    fill: "transparent",
    stroke: "#1493FF",
    rx: 1.611,
    ry: 1.628
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.008,
    cy: 56.812,
    stroke: "#1493FF",
    strokeWidth: 2,
    rx: 3.866,
    ry: 3.908
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#41E878",
    fillRule: "evenodd",
    d: "M140.749 47.043a.62.62 0 0 0-.621.621v1.682h-1.65a.628.628 0 1 0 0 1.256h1.65v1.681a.621.621 0 1 0 1.242 0v-1.681h1.65a.628.628 0 1 0 0-1.256h-1.65v-1.681a.62.62 0 0 0-.621-.622M180.131 59.458a.62.62 0 0 0-.621.621v1.682h-1.651a.629.629 0 0 0 0 1.256h1.651v1.681a.621.621 0 1 0 1.242 0v-1.681h1.65a.628.628 0 1 0 0-1.256h-1.65v-1.682a.62.62 0 0 0-.621-.62M211.622 27.505a.62.62 0 0 0-.621.621v1.682h-1.65a.628.628 0 1 0 0 1.256h1.65v1.681a.621.621 0 1 0 1.242 0v-1.681h1.65a.628.628 0 1 0 0-1.256h-1.65v-1.682a.62.62 0 0 0-.621-.62",
    clipRule: "evenodd"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.421,
    cy: 29.785,
    fill: "transparent",
    stroke: "#1493FF",
    strokeWidth: 2,
    rx: 2.899,
    ry: 2.931
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.803,
    cy: 67.558,
    fill: "transparent",
    stroke: "#1493FF",
    rx: 1.611,
    ry: 1.628
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.369,
    cy: 49.689,
    fill: "transparent",
    stroke: "#1493FF",
    strokeWidth: 2,
    rx: 3.866,
    ry: 3.908
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#41E878",
    fillRule: "evenodd",
    d: "M73.792 96.102c.342 0 .619.277.619.619v1.704h1.635a.634.634 0 1 1 0 1.268h-1.635v1.704a.619.619 0 1 1-1.238 0v-1.704h-1.635a.634.634 0 1 1 0-1.268h1.635v-1.704c0-.342.278-.62.62-.62M41.71 115.816c.34 0 .618.277.618.619v1.705h1.635a.633.633 0 1 1 0 1.267h-1.635v1.705a.619.619 0 0 1-1.238 0v-1.705h-1.635a.634.634 0 0 1 0-1.267h1.635v-1.705c0-.342.277-.619.62-.619M3.21 90.763c.34 0 .618.277.618.618v1.705h1.635a.634.634 0 0 1 0 1.267H3.828v1.705a.619.619 0 0 1-1.238 0v-1.705H.955a.634.634 0 1 1 0-1.267H2.59v-1.705c0-.341.277-.618.62-.618",
    clipRule: "evenodd"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#1493FF",
    rx: 1.604,
    ry: 1.643,
    transform: "matrix(-1 0 0 1 65.772 116.802)"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "transparent",
    stroke: "#1493FF",
    strokeWidth: 2,
    rx: 3.85,
    ry: 3.943,
    transform: "matrix(-1 0 0 1 18.11 98.772)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 72.731,
    r: 64,
    fill: "#D8DEE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F6FA",
    fillRule: "evenodd",
    d: "M84.234 1.894 45.587 44.817a1.31 1.31 0 0 0 .102 1.842l25.899 23.319 14.15 12.741 1.17 1.053 14.151 12.742 1.465 1.319 3.944 3.551a1.31 1.31 0 0 0 1.843-.09l38.647-42.923a1.31 1.31 0 0 0-.103-1.842l-3.944-3.551-1.464-1.319-14.151-12.741-1.17-1.053-14.151-12.742L86.077 1.804a1.31 1.31 0 0 0-1.843.09",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CEDAE7",
    d: "m64.167 63.197 40.088-44.522.363.326-40.089 44.523zM80.534 77.934l40.088-44.522.363.326-40.089 44.523z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBE4ED",
    fillRule: "evenodd",
    d: "M85.71 50.178 75.626 61.383a.327.327 0 0 1-.46.023l-1.37-1.23a.326.326 0 0 1-.026-.46l10.086-11.204a.327.327 0 0 1 .46-.023l1.37 1.23c.134.12.145.326.026.46m11.446 4.12-16.42 18.246a.327.327 0 0 1-.46.023l-5.303-4.763a.326.326 0 0 1-.026-.46L91.367 49.1a.327.327 0 0 1 .46-.023l5.304 4.764c.133.12.145.326.025.459m1.801-1.99 16.42-18.245a.326.326 0 0 0-.026-.46l-5.304-4.763a.327.327 0 0 0-.46.023l-16.42 18.245a.326.326 0 0 0 .026.46l5.304 4.763c.134.12.34.11.46-.023",
    clipRule: "evenodd"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.438,
    cy: 63.054,
    fill: "#DBE4ED",
    rx: 1.812,
    ry: 1.831,
    transform: "rotate(-48 72.438 63.054)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F8FB",
    fillRule: "evenodd",
    d: "m98.659 48.415 3.43-3.81a.326.326 0 0 0-.026-.46l-.821-.738a.327.327 0 0 0-.46.023l-3.43 3.811a.326.326 0 0 0 .025.46l.822.738c.133.12.34.11.46-.024M80.437 68.653l3.43-3.811a.326.326 0 0 0-.026-.46l-.822-.737a.327.327 0 0 0-.46.023l-3.43 3.811a.326.326 0 0 0 .026.46l.822.737c.133.12.34.11.46-.023M108.898 56.707l3.43-3.81a.325.325 0 0 0-.026-.46l-.821-.738a.327.327 0 0 0-.46.023l-3.43 3.811a.326.326 0 0 0 .026.46l.821.738c.134.12.341.109.46-.024M90.676 76.945l3.43-3.811a.326.326 0 0 0-.026-.46l-.821-.737a.327.327 0 0 0-.46.023l-3.43 3.811a.326.326 0 0 0 .025.46l.822.737c.134.12.34.11.46-.023",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBE4ED",
    d: "m66.5 27.53.76.678-.157.252q-.433.69-.433 1.356 0 .156.024.308.124.814.874 1.484l1.105 1.011q.192.172.373.285.888.557 1.631-.146l2.336-2.145q.214-.182.42-.055l.059.037.918.828q.157.136.157.3a.47.47 0 0 1-.082.248l-1.094 1.738q-.159.253-.362.123l-.089-.072-.41-.358-.1-.08q-.229-.142-.459.064l-1.261 1.18 1.164 1.049q.306.259.426.333.636.399 1.2.234c.374-.11.71-.396 1-.86l.218-.347.814.728.715-1.139a1 1 0 0 0 .173-.525q0-.35-.338-.65l-.234-.213.219-.347q.433-.69.433-1.362 0-.145-.02-.292-.115-.816-.87-1.506l-1.357-1.22a2 2 0 0 0-.297-.22q-.852-.533-1.699.254l-2.266 2.088-.19.115-.174-.042-.113-.087-.761-.678q-.157-.137-.157-.3a.47.47 0 0 1 .083-.248l.995-1.583q.158-.253.363-.124l.088.072.229.194q.282.243.559.016l1.273-1.173-.988-.904a3.5 3.5 0 0 0-.422-.314q-.635-.4-1.206-.239-.569.162-1.007.857l-.173.276-.762-.679z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 128,
    height: 129,
    x: 44,
    y: 8,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 72.731,
    r: 64,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M117.04 53.26c-.79 1.146-2.349 4.389 1.397 8.467l-.052.066 1.157 1.03 2.194 1.955 4.937 5.068 2.971 2.938.067 1.604.043 1.02.082 1.956 3.872-5.085-.662-.651.663.651.79-1.016v-3.034l-9.31-7.845-3.351-2.985-4.735-4.218z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "m135.741 70.818-7.26 8.577.225 4.91 7.035-5.532z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDC1B2",
    d: "M170.448 96.89 146.38 76.833c-.651-.542-1.242-1.677-1.313-2.52L144.035 61.9c-.07-.843-.661-1.978-1.313-2.52l-14.557-12.132-3.554-2.962-3.837-3.199a1.555 1.555 0 0 0-2.177.193l-2.159 2.569-.374.443c-.839 1.137-2.491 4.355 1.482 8.401l-.055.066 1.227 1.023 2.327 1.938 9.245 7.703.686 12.333-9.826 11.696-1.656 1.97-3.965 4.72a1.54 1.54 0 0 0 .193 2.168l32.474 27.064a1.554 1.554 0 0 0 2.176-.193l3.966-4.719 1.656-1.971 14.646-17.433a1.536 1.536 0 0 0-.192-2.167"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4DAD1",
    d: "m126.526 51.878-5.911-4.71a1.11 1.11 0 0 1-.15-1.613l2.057-2.34a1.25 1.25 0 0 1 1.694-.144l5.911 4.71c.507.404.574 1.13.15 1.613l-2.057 2.341a1.25 1.25 0 0 1-1.694.143"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCB3A5",
    d: "M141.761 98.037c-.65-.538-1.239-1.663-1.31-2.499l-.209-2.499-1.401-19.48.069.056.058.694.01-.011-.591-7.072-.267-3.18c-.07-.835-.659-1.96-1.31-2.499l-11.563-9.58-3.545-2.937-5.009-4.15-.067.079a6 6 0 0 0-.432.692l-.066-.054-.067.078c-.836 1.127-2.484 4.317 1.478 8.33l-.055.065 1.224 1.014 2.321 1.922 8.682 7.193 1.178 1.117.097 1.737.109 2.177.389 6.938-.037.044-9.762 11.55-1.651 1.954-3.955 4.68a1.52 1.52 0 0 0 .193 2.148l32.385 26.833c.65.538 1.627.452 2.171-.191l3.955-4.679 1.651-1.954 3.159-3.737z"
  }))));
};

export { SvgRedirectIllustration as default };
//# sourceMappingURL=redirect-illustration.svg.js.map
